/**
 * dataChangeNotifier.js
 * 데이터 변경 시 전역 이벤트를 발생시켜 다른 컴포넌트에 알림
 * dept, employee, dept_employee_link 테이블 변경 시 EmployeeTreeSelect 자동 업데이트
 */

/**
 * 부서 데이터 변경 이벤트 발생
 * @param {string} action - 'create', 'update', 'delete'
 * @param {object} data - 변경된 데이터 (선택적)
 */
export const notifyDeptChanged = (action, data = null) => {
  const event = new CustomEvent('deptChanged', {
    detail: { action, data, timestamp: new Date().toISOString() }
  });
  window.dispatchEvent(event);
  console.log(`[DataChangeNotifier] 부서 변경 알림: ${action}`, data);
};

/**
 * 직원 데이터 변경 이벤트 발생
 * @param {string} action - 'create', 'update', 'delete'
 * @param {object} data - 변경된 데이터 (선택적)
 */
export const notifyEmployeeChanged = (action, data = null) => {
  const event = new CustomEvent('employeeChanged', {
    detail: { action, data, timestamp: new Date().toISOString() }
  });
  window.dispatchEvent(event);
  console.log(`[DataChangeNotifier] 직원 변경 알림: ${action}`, data);
};

/**
 * 부서-직원 연결 데이터 변경 이벤트 발생
 * @param {string} action - 'create', 'update', 'delete'
 * @param {object} data - 변경된 데이터 (선택적)
 */
export const notifyDeptEmployeeLinkChanged = (action, data = null) => {
  const event = new CustomEvent('deptEmployeeLinkChanged', {
    detail: { action, data, timestamp: new Date().toISOString() }
  });
  window.dispatchEvent(event);
  console.log(`[DataChangeNotifier] 부서-직원 연결 변경 알림: ${action}`, data);
};

/**
 * 여러 데이터 타입 동시 변경 알림
 * @param {Array<string>} types - ['departments', 'employees']
 * @param {string} action - 'create', 'update', 'delete'
 * @param {object} data - 변경된 데이터 (선택적)
 */
export const notifyMultipleChanged = (types, action, data = null) => {
  types.forEach(type => {
    if (type === 'departments') {
      notifyDeptChanged(action, data);
    } else if (type === 'employees') {
      notifyEmployeeChanged(action, data);
    } else if (type === 'deptEmployeeLink') {
      notifyDeptEmployeeLinkChanged(action, data);
    }
  });
};

